<template>
  <div>
    <div
      style="position: fixed; top: 20px; z-index: 5; backdrop-filter: blur(2px)"
      v-if="LoaderStatus"
    >
      <Spinner />
    </div>
    <div class="dashboardAdmin-parentdiv bluebtn">
      <div
        class="
          dashboardAdmin-header
          d-flex
          justify-content-between
          align-items-center
          mt-4
        "
      >
        <div
          style="width: 70%"
          class="d-flex justify-content-between align-items-center"
        >
          <div class="dashboardAdmin-header-main-head">
            <span>Manage</span>
          </div>
        </div>

        <div
          style="width: 30%"
          class="d-flex justify-content-end align-items-center"
        >
          <div>
            <b-button
              v-if="tabName == 'customer' && roles.includes('PUSH_CUSTOMER')"
              @click="goToAddCustomer()"
              class="
                new-blueBtn
                w-100
                d-flex
                align-items-center
                justify-content-center
              "
            >
              <img
                src="../../assets/New-imgs/teams-icons/plus-btn.svg"
                alt=""
                class="mr-2"
              />

              <span class="">Add New Customer</span>
            </b-button>
            <b-button
              v-else-if="tabName == 'manage' && roles.includes('PUSH_VENDOR')"
              @click="goToAddVendor()"
              class="
                new-blueBtn
                w-100
                d-flex
                align-items-center
                justify-content-center
              "
            >
              <img
                src="../../assets/New-imgs/teams-icons/plus-btn.svg"
                alt=""
                class="mr-2"
              />

              <span class="">Add New Vendor</span>
            </b-button>
          </div>
        </div>
      </div>
      <div class="d-flex">
        <div
          class="relativeclass"
          :class="
            (tabName == 'manage' && allVendorDetails.length > 0) ||
            (tabName == 'customer' && allcustomerDetails.length > 0)
              ? 'manage-container d-flex justify-content-between'
              : 'manage-container w-100'
          "
        >
          <div class="newInt-control-tabs w-100">
            <b-tabs
              content-class="mt-1 position-relative p-3"
              v-model="tabIndex"
            >
              <b-tab
                @click="(tabName = 'customer'), resetFilter()"
                title="Customer"
                v-if="roles.includes('GET_CUSTOMER')"
              >
                <div
                  style="height: calc(100vh - 233px)"
                  v-if="
                    allcustomerDetails.length == 0 &&
                    searchQuery == '' &&
                    LoaderStatus == false
                  "
                  class="
                    d-flex
                    flex-column
                    align-items-center
                    justify-content-center
                  "
                >
                  <div>
                    <img
                      src="../../assets/New-imgs/CustVend-icons/manage-empty-cust-icons.svg"
                      alt=""
                    />
                  </div>

                  <div
                    class="teams-empty-container-font mt-4"
                    v-if="isApplied && storeTypeSelected == '1'"
                  >
                    There are no <strong> Active </strong> Customer's available
                  </div>

                  <div
                    class="teams-empty-container-font mt-4"
                    v-else-if="isApplied && storeTypeSelected == '0'"
                  >
                    There are no <strong> Inactive </strong> Customer's
                    available
                  </div>

                  <div v-else class="teams-empty-container-font mt-4">
                    There are no customers created, <br />
                    click
                    <strong> "Add New Customer"</strong>
                    button to add customers
                  </div>
                </div>
                <div
                  style="height: calc(100vh - 233px)"
                  class="
                    d-flex
                    flex-column
                    align-items-center
                    justify-content-center
                    w-100
                  "
                  v-else-if="
                    allcustomerDetails.length === 0 &&
                    searchQuery != 'Loader' &&
                    searchQuery != '' &&
                    LoaderStatus == false
                  "
                >
                  <div class="text-center">
                    <img
                      src="../../assets/New-imgs/CustVend-icons/manage-empty-cust-icons.svg"
                      alt=""
                    />
                  </div>
                  <div
                    class="
                      w-100
                      text-center
                      d-flex
                      align-items-center
                      justify-content-center
                      teams-empty-container-font
                    "
                  >
                    <span class="w-50">
                      No matching results for
                      <span class="searchtext wordbreak">
                        "{{ this.searchQuery }}"
                      </span>
                      .</span
                    >
                  </div>
                </div>

                <div
                  v-else-if="
                    allcustomerDetails.length > 0 && LoaderStatus == false
                  "
                >
                  <div
                    class="manage-cards-height pb-2"
                    ref="scrollToMe"
                    @scroll="onScroll"
                  >
                    <div class="d-flex flex-wrap">
                      <transition-group
                        name="cell"
                        class="d-flex flex-wrap gap-15 mt-1 ml-1"
                        tag="div"
                      >
                        <div
                          class="newInt-main-card relativeclass"
                          :class="
                            preview != cust.customerID
                              ? 'newInt-main-card'
                              : 'newInt-main-card-active'
                          "
                          v-for="cust in allcustomerDetails"
                          :key="cust.customerID"
                        >
                          <div class="d-flex justify-content-between">
                            <div class="relativeclass" style="width: 65%">
                              <div class="d-flex align-items-center">
                                <template>
                                  <img
                                    v-if="cust.customerType == '1'"
                                    src="../../assets/New-imgs/CustVend-icons/new int icon.svg"
                                    alt=""
                                  />
                                  <img
                                    v-else
                                    src="../../assets/New-imgs/CustVend-icons/new client icon.svg"
                                    alt=""
                                  />
                                </template>
                                <div
                                  class="
                                    text-truncate
                                    ml-2
                                    mr-2
                                    newInt-card-heading
                                    mt-1
                                  "
                                >
                                  <span
                                    v-b-tooltip.hover.bottom="cust.name"
                                    class="d-inline-block text-truncate"
                                    style="max-width: 100%"
                                  >
                                    {{ cust.name }}</span
                                  >
                                </div>
                              </div>
                            </div>
                            <div class="pointer d-flex align-items-center">
                              <div
                                v-if="!cust.active"
                                class="mr-2"
                                @click="activateCustModal(cust)"
                              >
                                <img
                                  class="newIcons-hover"
                                  v-b-tooltip.hover.top="'Activate'"
                                  src="../../assets/New-imgs/interviewProcess-icons/newInt-activateicon.svg"
                                  alt=""
                                />
                              </div>
                              <div
                                class="mr-2"
                                v-if="preview != cust.customerID"
                              >
                                <img
                                  class="newIcons-hover"
                                  v-b-tooltip.hover.top="'View'"
                                  src="../../assets/New-imgs/interviewProcess-icons/newInt-eyeicon.svg"
                                  alt=""
                                  @click="particularCandidatedetail(cust)"
                                />
                              </div>
                              <div
                                class="mr-2"
                                v-else
                                @click="(preview = ''), (showdetails = false)"
                              >
                                <img
                                  class="newIcons-hover"
                                  v-b-tooltip.hover.top="'Hide'"
                                  src="../../assets/New-imgs/interviewProcess-icons/newInt-notview-icon.svg"
                                  alt=""
                                />
                              </div>

                              <div v-if="cust.active" class="mr-2">
                                <img
                                  class="newIcons-hover"
                                  v-b-tooltip.hover.top="'Edit'"
                                  v-if="roles.includes('PUT_CUSTOMER')"
                                  src="../../assets/New-imgs/CustVend-icons/manage-edit-icon.svg"
                                  alt=""
                                  @click="editCustModal(cust)"
                                />
                              </div>
                              <div v-if="cust.active">
                                <img
                                  class="newIcons-hover"
                                  v-b-tooltip.hover.top="'Delete'"
                                  v-if="roles.includes('DELETE_CUSTOMER')"
                                  src="../../assets/New-imgs/CustVend-icons/manage-delete-icon.svg"
                                  @click="
                                    $bvModal.show('deleteCustModal');
                                    deleteCustModal(cust);
                                  "
                                  alt=""
                                />
                              </div>
                            </div>
                          </div>
                          <div class="relativeclass">
                            <div
                              class="newInt-inactive-text-box"
                              v-if="!cust.active"
                            >
                              <div class="inactive-txt">Inactive</div>
                            </div>
                            <div
                              class="
                                d-flex
                                justify-content-around
                                align-items-center
                                newInt-cards
                                mt-3
                              "
                            >
                              <div
                                class="d-flex align-items-center flex-column"
                              >
                                <div
                                  v-if="cust.details.jobs < 10"
                                  class="wb-greenfont"
                                >
                                  0{{ cust.details.jobs }}
                                </div>
                                <div v-else class="wb-greenfont">
                                  {{ cust.details.jobs }}
                                </div>
                                <div
                                  class="wbsmalltext"
                                  v-if="cust.details.jobs == 1"
                                >
                                  Job
                                </div>
                                <div class="wbsmalltext" v-else>Jobs</div>
                              </div>

                              <div
                                class="d-flex align-items-center flex-column"
                              >
                                <div
                                  v-if="cust.details.positions < 10"
                                  class="wb-bluefont"
                                >
                                  0{{ cust.details.positions }}
                                </div>
                                <div v-else class="wb-bluefont">
                                  {{ cust.details.positions }}
                                </div>
                                <div
                                  class="wbsmalltext"
                                  v-if="cust.details.positions == 1"
                                >
                                  Opening
                                </div>
                                <div class="wbsmalltext" v-else>Openings</div>
                              </div>
                              <div
                                class="d-flex align-items-center flex-column"
                              >
                                <div
                                  v-if="cust.details.selected < 10"
                                  class="wb-yellowfont"
                                >
                                  0{{ cust.details.selected }}
                                </div>
                                <div v-else class="wb-yellowfont">
                                  {{ cust.details.selected }}
                                </div>
                                <div class="wbsmalltext">Selected</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </transition-group>
                    </div>
                    <div
                      style="margin: auto"
                      v-if="showLoader"
                      class="d-flex justify-content-center mt-2"
                    >
                      <b-spinner label="Loading..."></b-spinner>
                    </div>
                  </div>
                </div>
              </b-tab>
              <b-tab
                @click="(tabName = 'manage'), resetFilter()"
                title="Vendor"
                v-if="roles.includes('GET_VENDOR')"
              >
                <div
                  style="height: calc(100vh - 233px)"
                  v-if="
                    allVendorDetails.length == 0 &&
                    searchQuery == '' &&
                    LoaderStatus == false
                  "
                  class="
                    d-flex
                    flex-column
                    align-items-center
                    justify-content-center
                  "
                >
                  <div>
                    <img
                      src="../../assets/New-imgs/CustVend-icons/manage-empty-cust-icons.svg"
                      alt=""
                    />
                  </div>

                  <div
                    class="teams-empty-container-font mt-4"
                    v-if="isApplied && storeTypeSelected == '1'"
                  >
                    There are no <strong> Active </strong> Vendor's available
                  </div>

                  <div
                    class="teams-empty-container-font mt-4"
                    v-else-if="isApplied && storeTypeSelected == '0'"
                  >
                    There are no <strong> Inactive </strong> Vendor's available
                  </div>

                  <div v-else class="teams-empty-container-font mt-4">
                    There are no vendors created, <br />
                    click
                    <strong> "Add New Vendor"</strong>
                    button to add vendors
                  </div>
                </div>
                <div
                  style="height: calc(100vh - 233px)"
                  class="
                    d-flex
                    flex-column
                    align-items-center
                    justify-content-center
                    w-100
                  "
                  v-else-if="
                    allVendorDetails.length == 0 &&
                    searchQuery != 'Loader' &&
                    searchQuery != '' &&
                    LoaderStatus == false
                  "
                >
                  <div>
                    <img
                      src="../../assets/New-imgs/CustVend-icons/manage-empty-cust-icons.svg"
                      alt=""
                    />
                  </div>
                  <div class="teams-empty-container-font">
                    <span>
                      No matching results for
                      <span class="searchtext"> "{{ this.searchQuery }}" </span>
                      .</span
                    >
                  </div>
                </div>
                <div
                  v-else-if="
                    allVendorDetails.length > 0 && LoaderStatus == false
                  "
                >
                  <div
                    class="manage-cards-height pb-2"
                    ref="scroll"
                    @scroll="onScroll"
                  >
                    <div class="d-flex flex-wrap">
                      <transition-group
                        name="cell"
                        class="d-flex flex-wrap gap-15 mt-1 ml-1"
                        tag="div"
                      >
                        <div
                          class="newInt-main-card relativeclass"
                          :class="
                            vendorpreview != vend.vendorID
                              ? 'newInt-main-card'
                              : 'newInt-main-card-active'
                          "
                          v-for="vend in allVendorDetails"
                          :key="vend.vendorID"
                        >
                          <div class="d-flex justify-content-between">
                            <div class="relativeclass" style="width: 65%">
                              <div class="d-flex align-items-center">
                                <img
                                  src="../../assets/New-imgs/CustVend-icons/vend-icon.svg"
                                  alt=""
                                />
                                <div
                                  class="
                                    text-truncate
                                    ml-2
                                    mr-2
                                    newInt-card-heading
                                    mt-1
                                  "
                                >
                                  <span
                                    v-b-tooltip.hover.bottom="vend.name"
                                    class="d-inline-block text-truncate"
                                    style="max-width: 100%"
                                  >
                                    {{ vend.name }}</span
                                  >
                                </div>
                              </div>
                            </div>
                            <div class="pointer d-flex align-items-center">
                              <div
                                v-if="!vend.active"
                                class="mr-2"
                                @click="activateVendModal(vend)"
                              >
                                <img
                                  class="newIcons-hover"
                                  v-b-tooltip.hover.top="'Activate'"
                                  src="../../assets/New-imgs/interviewProcess-icons/newInt-activateicon.svg"
                                  alt=""
                                />
                              </div>
                              <div
                                class="mr-2"
                                v-if="vendorpreview != vend.vendorID"
                              >
                                <img
                                  class="newIcons-hover"
                                  v-b-tooltip.hover.top="'View'"
                                  src="../../assets/New-imgs/interviewProcess-icons/newInt-eyeicon.svg"
                                  alt=""
                                  @click="
                                    particularVendordetail(vend),
                                      (showTypeCard = false),
                                      (showsortcard = false)
                                  "
                                />
                              </div>
                              <div
                                class="mr-2"
                                v-else
                                @click="
                                  (vendorpreview = ''),
                                    (vendshowdetails = false)
                                "
                              >
                                <img
                                  class="newIcons-hover"
                                  v-b-tooltip.hover.top="'Hide'"
                                  src="../../assets/New-imgs/interviewProcess-icons/newInt-notview-icon.svg"
                                  alt=""
                                />
                              </div>

                              <div class="mr-2" v-if="vend.active">
                                <img
                                  class="newIcons-hover"
                                  v-b-tooltip.hover.top="'Edit'"
                                  v-if="roles.includes('PUT_VENDOR')"
                                  src="../../assets/New-imgs/CustVend-icons/manage-edit-icon.svg"
                                  alt=""
                                  @click="editVendModal(vend)"
                                />
                              </div>
                              <div v-if="vend.active">
                                <img
                                  class="newIcons-hover"
                                  v-b-tooltip.hover.top="'Delete'"
                                  v-if="roles.includes('DELETE_VENDOR')"
                                  src="../../assets/New-imgs/CustVend-icons/manage-delete-icon.svg"
                                  @click="
                                    $bvModal.show('deleteVendModal');
                                    deleteVendor(vend);
                                  "
                                  alt=""
                                />
                              </div>
                            </div>
                          </div>
                          <div class="relativeclass">
                            <div
                              class="newInt-inactive-text-box"
                              v-if="!vend.active"
                            >
                              <div class="inactive-txt">Inactive</div>
                            </div>
                            <div
                              class="
                                d-flex
                                align-items-center
                                justify-content-around
                                newInt-cards
                                mt-3
                              "
                            >
                              <div
                                style="width: 24%"
                                class="d-flex text-center flex-column"
                              >
                                <div
                                  v-if="vend.details.jobs < 10"
                                  class="wb-greenfont"
                                >
                                  0{{ vend.details.jobs }}
                                </div>
                                <div v-else class="wb-greenfont">
                                  {{ vend.details.jobs }}
                                </div>
                                <div class="wbsmalltext">Tagged Jobs</div>
                              </div>

                              <div
                                style="width: 38%"
                                class="d-flex text-center flex-column"
                              >
                                <div
                                  v-if="vend.details.candidates < 10"
                                  class="wb-bluefont"
                                >
                                  0{{ vend.details.candidates }}
                                </div>
                                <div v-else class="wb-bluefont">
                                  {{ vend.details.candidates }}
                                </div>
                                <div class="wbsmalltext">Candidates Added</div>
                              </div>

                              <div
                                style="width: 38%"
                                class="d-flex text-center flex-column"
                              >
                                <div
                                  v-if="vend.details.pushed < 10"
                                  class="wb-yellowfont"
                                >
                                  0{{ vend.details.pushed }}
                                </div>
                                <div v-else class="wb-yellowfont">
                                  {{ vend.details.pushed }}
                                </div>

                                <div class="wbsmalltext">Candidates Pushed</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </transition-group>
                    </div>
                    <div
                      style="margin: auto"
                      v-if="showLoader"
                      class="d-flex justify-content-center mt-2"
                    >
                      <b-spinner label="Loading..."></b-spinner>
                    </div>
                  </div>
                </div>
              </b-tab>
            </b-tabs>
          </div>
          <div
            ref="rec"
            v-closable="{
              exclude: ['rec', 'recdropdown'],
              handler: 'cancelFilter',
            }"
          >
            <div>
              <div
                class="IHD-filter-count mb-3 manage-applied"
                v-if="filterApplied"
              ></div>

              <b-button class="acs-addBtn btn-position" @click="openCloseFilter"
                ><img
                  class="mr-2"
                  src="../../assets/img/accessconnew/whiteFilter.svg"
                  alt=""
                />Filter</b-button
              >
            </div>
            <div
              v-if="showfiltercard"
              class="acs-filter p-3"
              style="width: 300px"
            >
              <div>
                <div v-if="tabName == 'customer'">
                  <div class="acs-black-txt">Customer Type :</div>
                  <div
                    @click="
                      (showCustType = !showCustType),
                        ((showsortcard = false), (showTypeCard = false))
                    "
                    class="acs-filter-dropdown mt-2 position-relative pointer"
                  >
                    <span class="newManage-dropdown-place">
                      {{ custType }}
                    </span>

                    <img
                      src="../../assets/img/accessconnew/blueDownArrowSmall.svg"
                      alt=""
                    />
                  </div>
                  <div v-if="showCustType" class="relativeclass">
                    <div class="newInt-radio-dropdown p-0">
                      <b-form-group class="sec-mcq-datacard">
                        <b-form-radio-group
                          class="
                            newInt-radio-dropdown-inner-content
                            w-100
                            relativeclass
                          "
                          size="sm"
                          v-model="custSelected"
                          :options="custOptions"
                          @change="showCustType = false"
                          buttons
                          stacked
                        >
                          <!-- :class="checkDefaultCust() ? 'relativeclass' : ''" -->
                          <!-- <div
                            class="default-content"
                            v-if="checkDefaultCust()"
                          >
                            Default
                          </div> -->
                        </b-form-radio-group>
                      </b-form-group>
                    </div>
                  </div>
                </div>
                <div :class="tabName == 'customer' ? 'mt-3' : ''">
                  <div class="acs-black-txt">Sort By :</div>
                  <div
                    @click="
                      (showsortcard = !showsortcard),
                        (showTypeCard = false),
                        (showCustType = false)
                    "
                    class="acs-filter-dropdown mt-2 position-relative pointer"
                  >
                    <span class="newManage-dropdown-place">
                      {{ sortName }}
                    </span>

                    <img
                      src="../../assets/img/accessconnew/blueDownArrowSmall.svg"
                      alt=""
                    />
                  </div>
                  <div v-if="showsortcard" class="relativeclass">
                    <div class="newInt-radio-dropdown p-0">
                      <b-form-group class="sec-mcq-datacard">
                        <b-form-radio-group
                          class="newInt-radio-dropdown-inner-content w-100"
                          size="sm"
                          v-model="sort_selected"
                          :options="sort_options"
                          @change="showsortcard = false"
                          buttons
                          stacked
                        >
                          <!-- :class="checkDefaultSort() ? 'relativeclass' : ''" -->
                          <!-- <div
                            class="default-content"
                            v-if="checkDefaultSort()"
                          >
                            Default
                          </div> -->
                        </b-form-radio-group>
                      </b-form-group>
                    </div>
                  </div>
                </div>
                <div class="mt-3">
                  <div class="acs-black-txt" v-if="tabName == 'customer'">
                    Customer Status :
                  </div>
                  <div v-else-if="tabName == 'manage'">Vendor Status :</div>

                  <div
                    @click="
                      (showTypeCard = !showTypeCard),
                        (showCustType = false),
                        (showsortcard = false)
                    "
                    class="acs-filter-dropdown mt-2 position-relative pointer"
                  >
                    <span class="newManage-dropdown-place">
                      {{
                        typeSelected === "0"
                          ? "Inactive"
                          : typeSelected === "1"
                          ? "Active"
                          : "All"
                      }}</span
                    >
                    <img
                      src="../../assets/img/accessconnew/blueDownArrowSmall.svg"
                      alt=""
                    />
                  </div>
                  <div v-if="showTypeCard" class="relativeclass">
                    <div class="newInt-radio-dropdown p-0">
                      <b-form-group class="sec-mcq-datacard">
                        <b-form-radio-group
                          class="newInt-radio-dropdown-inner-content w-100"
                          size="sm"
                          v-model="typeSelected"
                          :options="typeOptions"
                          @change="showTypeCard = false"
                          buttons
                          stacked
                        >
                        </b-form-radio-group>
                      </b-form-group>
                    </div>
                  </div>
                </div>
                <div class="d-flex justify-content-between mt-4 bluebtn">
                  <b-button class="acs-cancelBtn-filter" @click="cancelFilter()"
                    >Cancel</b-button
                  >
                  <div class="d-flex">
                    <b-button
                      class="acs-cancelBtn-filter mr-3"
                      @click="resetVal()"
                      >Reset</b-button
                    >
                    <b-button
                      class="acs-cancelBtn-filter"
                      @click="applyFilterMethod"
                      >Apply</b-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="
            (allVendorDetails.length != 0 && tabName == 'manage') ||
            (allcustomerDetails.length != 0 && tabName == 'customer')
          "
          class="manage-right-container relativeclass ml-2"
        >
          <div
            class="
              d-flex
              align-items-center
              justify-content-center
              flex-column
              h-100
            "
            v-if="!showdetails && tabName == 'customer'"
          >
            <div class="">
              <img
                src="../../assets/New-imgs/CustVend-icons/manage-rs-nodata.svg"
                alt=""
              />
            </div>

            <div class="teams-empty-container-font">
              Click on the eye icon to view customer details
            </div>
          </div>
          <div
            class="
              d-flex
              align-items-center
              justify-content-center
              flex-column
              h-100
            "
            v-if="!vendshowdetails && tabName == 'manage'"
          >
            <div class="">
              <img
                src="../../assets/New-imgs/CustVend-icons/manage-rs-nodata.svg"
                alt=""
              />
            </div>
            <div class="teams-empty-container-font">
              Click on the eye icon to view vendor details
            </div>
          </div>
          <div
            v-if="showdetails && tabName == 'customer'"
            class="newInt-rs-container"
          >
            <div class="newInt-rs-mainhead mt-3 ml-2">Customer Details</div>
            <hr />
            <div
              class="mr-2 mb-1"
              :class="
                !singleCustomer.active
                  ? 'manage-right-container-bottom-inactive'
                  : 'manage-right-container-bottom'
              "
            >
              <div
                v-for="(field, index) in customFields"
                :key="index"
                :class="index !== 0 ? 'mt-3' : ''"
              >
                <div class="newInt-rs-head">{{ field.label }}</div>
                <div v-if="checkFieldKeys(field, singleCustomer)">-</div>
                <div
                  class="newInt-rs-subhead mt-1"
                  style="word-break: break-word"
                  v-else-if="Object.keys(singleCustomer).length > 0"
                >
                  <template v-if="isHtmlContent(field, singleCustomer)">
                    <div v-html="checkValuesOfKey(field, singleCustomer)"></div>
                  </template>
                  <template v-else>
                    {{ checkValuesOfKey(field, singleCustomer) }}
                  </template>
                </div>
              </div>
              <div class="mt-3">
                <div class="newInt-rs-head">Created On</div>
                <div class="newInt-rs-subhead mt-1">
                  {{ formattedDate(singleCustomer.createdAt) }}
                </div>
              </div>
              <hr class="mb-2 mt-2" />
              <div
                class="
                  d-flex
                  align-items-center
                  justify-content-between
                  manange-opngs-container
                "
              >
                <div class="d-flex align-items-center">
                  <div>
                    <img
                      src="../../assets/New-imgs/CustVend-icons/manage-openings-icon.svg"
                      alt=""
                    />
                  </div>
                  <div class="ml-3 manange-opngs-container-font">Openings</div>
                </div>
                <div class="manange-opngs-container-count">
                  {{ singleCustomer.details.positions }}
                </div>
              </div>

              <div
                class="
                  mt-2
                  d-flex
                  align-items-center
                  justify-content-between
                  manange-opngs-container
                "
              >
                <div class="d-flex align-items-center">
                  <div>
                    <img
                      src="../../assets/New-imgs/CustVend-icons/manage-inprogress-icon.svg"
                      alt=""
                    />
                  </div>
                  <div class="ml-3 manange-opngs-container-font">
                    In Progress
                  </div>
                </div>
                <div class="manange-opngs-container-count">
                  {{ singleCustomer.details.inprogress }}
                </div>
              </div>

              <div
                class="
                  mt-2
                  d-flex
                  align-items-center
                  justify-content-between
                  manange-opngs-container
                "
              >
                <div class="d-flex align-items-center">
                  <div>
                    <img
                      src="../../assets/New-imgs/CustVend-icons/manage-cand-icon.svg"
                      alt=""
                    />
                  </div>
                  <div class="ml-3 manange-opngs-container-font">
                    Candidates
                  </div>
                </div>
                <div class="manange-opngs-container-count">
                  {{ singleCustomer.details.candidates }}
                </div>
              </div>

              <div
                class="
                  mt-2
                  d-flex
                  align-items-center
                  justify-content-between
                  manange-opngs-container
                "
              >
                <div class="d-flex align-items-center">
                  <div>
                    <img
                      src="../../assets/New-imgs/CustVend-icons/manage-full-icon.svg"
                      alt=""
                    />
                  </div>
                  <div class="ml-3 manange-opngs-container-font">Fulfilled</div>
                </div>
                <div class="manange-opngs-container-count">
                  {{ singleCustomer.details.selected }}
                </div>
              </div>

              <div
                class="
                  mt-2
                  d-flex
                  align-items-center
                  justify-content-between
                  manange-opngs-container
                "
              >
                <div class="d-flex align-items-center">
                  <div>
                    <img
                      src="../../assets/New-imgs/CustVend-icons/manage-cancel-icon.svg"
                      alt=""
                    />
                  </div>
                  <div class="ml-3 manange-opngs-container-font">Cancelled</div>
                </div>
                <div class="manange-opngs-container-count">
                  {{ singleCustomer.details.rejected }}
                </div>
              </div>
            </div>
            <div
              v-if="!singleCustomer.active"
              class="d-flex align-items-center justify-content-end"
              style="height: 50px; border-top: 1px solid rgba(0, 0, 0, 0.1)"
            >
              <div
                class="pointer bluebtn"
                @click="activateCustModal(singleCustomer)"
              >
                <b-button class="new-blueBtn">
                  <img
                    src="../../assets/New-imgs/interviewProcess-icons/newInt-activateBtn.svg"
                    alt=""
                    class="mr-2 mb-1"
                  />
                  <span> Activate </span>
                </b-button>
              </div>
            </div>
          </div>
          <div
            v-if="vendshowdetails && tabName == 'manage'"
            class="newInt-rs-container"
          >
            <div class="newInt-rs-mainhead mt-3 ml-2">Vendor Details</div>
            <hr class="mb-2 mt-2" />
            <div
              class="mr-2 mb-1"
              :class="
                !singleVendor.active
                  ? 'manage-right-container-bottom-inactive'
                  : 'manage-right-container-bottom'
              "
            >
              <div
                v-for="(field, index) in customFields"
                :key="index"
                :class="index !== 0 ? 'mt-3' : ''"
              >
                <div class="newInt-rs-head">{{ field.label }}</div>

                <div v-if="checkFieldKeys(field, singleVendor)">-</div>
                <div
                  class="newInt-rs-subhead mt-1"
                  style="word-break: break-word"
                  v-else-if="Object.keys(singleVendor).length > 0"
                >
                  <template v-if="isHtmlContent(field, singleVendor)">
                    <div v-html="checkValuesOfKey(field, singleVendor)"></div>
                  </template>
                  <template v-else>
                    {{ checkValuesOfKey(field, singleVendor) }}
                  </template>
                </div>
              </div>
              <div class="mt-3">
                <div class="newInt-rs-head">Created On</div>
                <div class="newInt-rs-subhead mt-1">
                  {{ singleVendor.createdAt }}
                </div>
              </div>
            </div>
            <div
              v-if="!singleVendor.active"
              class="d-flex align-items-center justify-content-end"
              style="height: 75px; border-top: 1px solid rgba(0, 0, 0, 0.1)"
            >
              <div
                class="pointer bluebtn"
                @click="activateVendModal(singleVendor)"
              >
                <b-button class="new-blueBtn mr-2">
                  <img
                    src="../../assets/New-imgs/interviewProcess-icons/newInt-activateBtn.svg"
                    alt=""
                    class="mr-2 mb-1"
                  />
                  <span> Activate </span>
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-----------------  Vendor Delete Popup starts -------->
    <b-modal id="deleteVendModal" centered hide-footer hide-header @hidden="$bvModal.hide('deleteVendModal')">
      <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center w-100">
          <div class="mb-3">
            <img
              src="../../assets/New-imgs/teams-icons/teams-delete-main-icon.svg"
              alt=""
            />
          </div>
          <div class="ml-3 w-100">
            <div class="d-flex justify-content-between">
              <div class="teams-modal-head">Delete Vendor</div>
              <div
                @click="$bvModal.hide('deleteVendModal')"
                class="d-flex align-items-center justify-content-end"
              >
                <img
                  src="../../assets/New-imgs/teams-icons/teams-close-icon.svg"
                  alt=""
                  class="pointer rotate-on-hover"
                />
              </div>
            </div>
            <div class="mt-1 teams-delete-folder-font" style="width: 95%">
              Are you sure you want to delete this vendor <br /><strong
                >"{{ this.delVendor.name }}"?
              </strong>
              This action cannot be undone.
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-end mt-4 bluebtn">
        <b-button
          class="new-whiteBtn mr-3"
          @click="$bvModal.hide('deleteVendModal')"
          >Cancel</b-button
        >
        <b-button class="new-blueBtn mr-3" @click="deleteVen(delVendor)"
          >Delete</b-button
        >
      </div>
    </b-modal>

    <!----------------- Vendor Delete Popup ends -------->

    <!-----------------  Customer Delete Popup starts -------->
    <b-modal id="deleteCustModal" centered hide-footer hide-header @hidden="$bvModal.hide('deleteCustModal')">
      <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center w-100">
          <div class="mb-3">
            <img
              src="../../assets/New-imgs/teams-icons/teams-delete-main-icon.svg"
              alt=""
            />
          </div>
          <div class="ml-3 w-100">
            <div class="d-flex justify-content-between">
              <div class="teams-modal-head">Delete Customer</div>
              <div
                @click="$bvModal.hide('deleteCustModal')"
                class="d-flex align-items-center justify-content-end"
              >
                <img
                  src="../../assets/New-imgs/teams-icons/teams-close-icon.svg"
                  alt=""
                  class="pointer rotate-on-hover"
                />
              </div>
            </div>
            <div class="mt-1 teams-delete-folder-font" style="width: 95%">
              Are you sure you want to delete this customer <br />
              <strong>"{{ this.delCustomer.name }}"? </strong>
              This action cannot be undone.
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-end mt-4 bluebtn">
        <b-button
          class="new-whiteBtn mr-3"
          @click="$bvModal.hide('deleteCustModal')"
          >Cancel</b-button
        >
        <b-button class="new-blueBtn mr-3" @click="deleteCustomer(delCustomer)"
          >Delete</b-button
        >
      </div>
    </b-modal>

    <!----------------- Customer Delete Popup ends -------->

    <ConfirmModal
      v-if="warning"
      :confirmModal="warning"
      @close-confirm="warning = false"
      @handle-submit="warning = false"
      :button="'Okay'"
      :header="'Warning'"
      :hideCancel="true"
      :msg="'This customer cannot be deleted as there are active jobs under this customer!'"
      :imageSrc="require('../../assets/img/feedbackform/confirmIcon.svg')"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import toast from "../../components/mixin/toast";
import Spinner from "../../components/fixedcomponents/Spinner.vue";
import {
  getCustomer,
  getVendor,
  deleteCustomer,
  getCustomerFields,
  deleteVendor,
} from "../../utils/apiFunctions.js";
import ConfirmModal from "../../views/InterviewProcess/ConfirmModal.vue";

export default {
  name: "Manage",
  components: {
    Spinner,
    ConfirmModal,
  },
  mixins: [toast],
  data() {
    return {
      // Numbers
      activeForCust: 1,
      activeForVend: 1,
      sortOrder: -1,
      tabIndex: 0,
      page: 0,
      count: 30,
      pageEnd: null,
      total: null,

      // Boolean
      filterApplied: false,
      warning: false,
      showfiltercard: false,
      showsortcard: false,
      showTypeCard: false,
      LoaderStatus: false,
      filterModelValue: false,
      showCustType: false,
      vendshowdetails: false,
      showdetails: false,
      vendoreditoptions: false,
      customer: true,
      vendor: false,
      manageTrue: true,
      isApplied: false,

      // strings
      sortColumn: "updatedAt",
      customerStatusType: "1",
      sort_selected: "6",
      typeSelected: "1",
      custSelected: "",
      storeCustSelected: "",
      storeSortSelected: "6",
      storeTypeSelected: "1",
      vendorpreview: "",
      preview: "",
      tabName: "",

      // array
      delCustomer: [],
      delVendor: [],
      allVendorDetails: [],
      allcustomerDetails: [],
      internalDepartment: [],
      clientHiring: [],
      customFields: [],
      vendorFields: [],
      sort_options: [
        { text: "Name(Asce)", value: "1" },
        { text: "Name(Desc)", value: "2" },
        { text: "Date Created(Asce)", value: "3" },
        { text: "Date Created(Desc)", value: "4" },
        { text: "Date Modified(Asce)", value: "5" },
        { text: "Date Modified(Desc)", value: "6", default: true },
      ],
      typeOptions: [
        { text: "All", value: "2" },
        { text: "Active", value: "1", default: true },
        { text: "Inactive", value: "0" },
      ],
      custOptions: [
        { text: "All", value: "", default: true },
        { text: "Internal Department", value: "1" },
        { text: "Client Hiring", value: "2" },
      ],

      // Objects
      singleVendor: {},
      singleCustomer: {},
    };
  },

  computed: {
    ...mapGetters(["roles"]),
    ...mapGetters("searchVUEX", {
      searchQuery: "getSearchQuery",
    }),
    custType() {
      if (this.custSelected === "1") {
        return "Internal Department";
      } else if (this.custSelected === "2") {
        return "Client Hiring";
      } else {
        return "All";
      }
    },
    sortName() {
      if (this.sort_selected == "1") {
        return "Name(Asce)";
      } else if (this.sort_selected == "2") {
        return "Name(Desc)";
      } else if (this.sort_selected == "3") {
        return "Date Created(Asce)";
      } else if (this.sort_selected == "4") {
        return "Date Created(Desc)";
      } else if (this.sort_selected == "5") {
        return "Date Modified(Asce)";
      }
      return "Date Modified(Desc)";
    },
  },
  watch: {
    $route() {
      this.showdetails = false;
      this.vendshowdetails = false;
      if (this.$route.query.status == "manage") {
        this.tabName = "manage";
        this.tabIndex = 1;
      } else {
        this.tabName = "customer";
        this.tabIndex = 0;
      }
      this.tabRedirect();
    },
    tabName(newValue, oldValue) {
      if (newValue != oldValue) {
        this.$store.commit("searchVUEX/saveSearchQuery", "");
      }
      if (newValue == "customer") {
        this.$router.push({
          name: `Manage`,
          query: {
            status: "customer",
            type: this.typeSelected,
            sort: this.sort_selected,
            customerType: this.custSelected,
          },
        });
        this.$store.commit("vendorVUEX/newvendorValue", false);
        this.vendshowdetails = false;
        this.vendorpreview = "";
        this.saveSort();
      } else {
        this.$router.push({
          name: "Manage",
          query: {
            status: "manage",
            type: this.typeSelected,
            sort: this.sort_selected,
          },
        });
        this.$store.commit("vendorVUEX/newvendorValue", true);
        this.showdetails = false;
        this.preview = "";
        this.saveSort();
      }
    },
    searchQuery(newValue, oldValue) {
      if (newValue != oldValue) {
        if (newValue != "Loader") {
          this.resetPagination();
          this.preview = "";
          this.showdetails = false;
          this.vendorpreview = "";
          this.vendshowdetails = false;
        }
      }
    },
  },
  created() {
    if (
      !this.roles.includes("GET_CUSTOMER") &&
      this.roles.includes("GET_VENDOR")
    ) {
      this.tabName = "manage";
    }
    // this.$store.commit("searchVUEX/saveSearchQuery", "");

    if (this.$route.query.status == "manage") {
      this.$store.commit("vendorVUEX/newvendorValue", true);
      this.tabName = "manage";
      this.tabIndex = 1;
    } else if (this.$route.query.status == "customer") {
      this.$store.commit("vendorVUEX/newvendorValue", false);
      this.tabName = "customer";
    }
    // Managing tab redirect based on Customer type or Vendor type and Sort
    this.tabRedirect();
    this.getCustomFields("2");
    this.getCustomFields("3");
    this.getCustomFields("4");
  },

  methods: {
    formattedDate(dateStr) {
      if (dateStr) {
        const [year, month, day] = dateStr.split("-");
        return `${day}-${month}-${year}`;
      }
      return null;
    },
    checkDefaultType() {
      for (let i in this.typeOptions) {
        if (this.typeOptions[i].default) {
          return true;
        }
      }
      return false;
    },
    checkFieldKeys(field, data) {
      let fieldKey;
      if (field.fieldType == "default") {
        if (data[field.key] == "" || data[field.key] == undefined) {
          fieldKey = true;
        } else {
          fieldKey = false;
        }
      } else {
        if (
          data.customFields[field.key] == "" ||
          data.customFields[field.key] == undefined
        ) {
          fieldKey = true;
        } else {
          fieldKey = false;
        }
      }
      return fieldKey;
    },
    isHtmlContent(field, data) {
      const customField = data.customFields[field.key];
      if (
        (field.controlType == "rich_text_box" &&
          typeof data[field.key] === "string" &&
          data[field.key] !== "") ||
        (field.controlType == "rich_text_box" &&
          typeof customField === "string" &&
          customField !== "")
      ) {
        return true;
      } else {
        return false;
      }
    },
    checkValuesOfKey(field, data) {
      let fieldValue;
      if (field.fieldType === "default") {
        if (
          field.controlType == "multi_select" &&
          Array.isArray(data[field.key])
        ) {
          let usernameArray = data[field.key].map((obj) => obj.username);
          fieldValue = usernameArray.join(", ");
        } else if (
          field.controlType == "single_select" &&
          typeof data[field.key] === "string" &&
          data[field.key] !== ""
        ) {
          fieldValue = data[field.key].label;
        } else if (
          field.controlType == "upload_file" &&
          typeof data[field.key] === "string" &&
          data[field.key] !== ""
        ) {
          let lastIndex = data[field.key].lastIndexOf("/");
          fieldValue = data[field.key].substring(lastIndex + 1);
        } else if (
          field.controlType == "multi_text" &&
          Array.isArray(data[field.key])
        ) {
          fieldValue = data[field.key].join(", ");
        } else {
          fieldValue = data[field.key];
        }
      } else {
        const customField = data.customFields[field.key];
        if (field.controlType == "multi_select" && Array.isArray(customField)) {
          if (field.key == "buHead" || field.key == "hiringManager") {
            let usernameArray = customField.map((obj) => obj.username);
            fieldValue = usernameArray.join(", ");
          } else {
            const fieldValues = [];
            field.values.forEach((val) => {
              customField.forEach((key) => {
                if (val.key === key) {
                  fieldValues.push(val.label);
                }
              });
            });
            fieldValue = fieldValues.join(", ");
          }
        } else if (
          field.controlType == "single_select" &&
          typeof customField === "string" &&
          customField !== ""
        ) {
          let val;
          field.values.forEach((value) => {
            if (value.key === customField) {
              val = value.label;
            }
          });
          fieldValue = val;
        } else if (
          field.controlType == "upload_file" &&
          typeof customField === "string" &&
          customField !== ""
        ) {
          let lastIndex = customField.lastIndexOf("/");
          fieldValue = customField.substring(lastIndex + 1);
        } else if (
          field.controlType === "multi_text" &&
          Array.isArray(customField)
        ) {
          fieldValue = customField.join(", ");
        } else {
          fieldValue = customField;
        }
      }

      return fieldValue;
    },
    async getCustomFields(data) {
      let payload = {
        parentID: data,
      };
      const res = await getCustomerFields(payload);
      if (res.status == 200) {
        if (data == "2") {
          this.internalDepartment = res.data.data.fields;
        } else if (data == "3") {
          this.clientHiring = res.data.data.fields;
        } else {
          this.vendorFields = res.data.data.fields;
        }
      }
    },
    openCloseFilter() {
      // this.isApplied = false;
      this.showfiltercard = !this.showfiltercard;
      this.showCustType = false;
      this.showsortcard = false;
      this.showTypeCard = false;
      if (!this.isApplied) {
        this.custSelected = this.storeCustSelected;
        this.sort_selected = this.storeSortSelected;
        this.typeSelected = this.storeTypeSelected;
      }
    },
    applyFilterMethod() {
      this.isApplied = true;
      this.filterApplied = true;
      this.showfiltercard = false;
      this.saveSort();
      this.storeCustSelected = this.custSelected;
      this.storeSortSelected = this.sort_selected;
      this.storeTypeSelected = this.typeSelected;
      if (
        this.tabName == "customer" ||
        this.$route.query.status === "customer"
      ) {
        this.$router.push({
          name: `Manage`,
          query: {
            status: "customer",
            type: this.typeSelected,
            sort: this.sort_selected,
            customerType: this.custSelected,
          },
        });
      } else {
        this.$router.push({
          name: "Manage",
          query: {
            status: "manage",
            type: this.typeSelected,
            sort: this.sort_selected,
          },
        });
      }
    },
    saveSort() {
      this.LoaderStatus = true;
      if (this.sort_selected == "1") {
        this.sortColumn = "name";
        this.sortOrder = "1";
      } else if (this.sort_selected == "2") {
        this.sortColumn = "name";
        this.sortOrder = "-1";
      } else if (this.sort_selected == "3") {
        this.sortColumn = "createdAt";
        this.sortOrder = "1";
      } else if (this.sort_selected == "4") {
        this.sortColumn = "createdAt";
        this.sortOrder = "-1";
      } else if (this.sort_selected == "5") {
        this.sortColumn = "updatedAt";
        this.sortOrder = "1";
      } else {
        this.sortColumn = "updatedAt";
        this.sortOrder = "-1";
      }
      this.showCustType = false;
      this.showsortcard = false;
      this.showTypeCard = false;
      this.showfiltercard = false;
      this.resetPagination();
    },
    cancelFilter() {
      this.showCustType = false;
      this.showsortcard = false;
      this.showTypeCard = false;
      this.showfiltercard = false;
      if (!this.isApplied) {
        this.custSelected = this.storeCustSelected;
        this.sort_selected = this.storeSortSelected;
        this.typeSelected = this.storeTypeSelected;
      }
    },
    resetFilter() {
      this.sort_selected = "6";
      this.typeSelected = "1";
      this.custSelected = "";
      this.storeCustSelected = "";
      this.storeSortSelected = "6";
      this.storeTypeSelected = "1";
      this.filterApplied = false;
    },
    resetVal() {
      this.sort_selected = "6";
      this.typeSelected = "1";
      this.custSelected = "";
      this.storeCustSelected = "";
      this.storeSortSelected = "6";
      this.storeTypeSelected = "1";
      this.showCustType = false;
      this.showsortcard = false;
      this.showTypeCard = false;
      this.showfiltercard = false;
      this.filterApplied = false;
      this.LoaderStatus = true;
      this.resetPagination();
      if (
        this.tabName == "customer" ||
        this.$route.query.status === "customer"
      ) {
        this.$router.push({
          name: `Manage`,
          query: {
            status: "customer",
            type: this.typeSelected,
            sort: this.sort_selected,
            customerType: this.custSelected,
          },
        });
      } else {
        this.$router.push({
          name: "Manage",
          query: {
            status: "manage",
            type: this.typeSelected,
            sort: this.sort_selected,
          },
        });
      }
    },
    // Managing tab redirect based on Customer type or Vendor type and Sort
    tabRedirect() {
      if (this.$route.query.sort || this.$route.query.type) {
        this.sort_selected = this.$route.query.sort;
        this.typeSelected = this.$route.query.type;
      }
      if (
        this.$route.query.status === "customer" ||
        this.tabName === "customer"
      ) {
        if (this.$route.query.customerType) {
          this.custSelected = this.$route.query.customerType;
        }
      }
      this.storeSortSelected = this.sort_selected;
      this.storeCustSelected = this.custSelected;
      this.storeTypeSelected = this.typeSelected;
      this.preview = "";
      this.vendorpreview = "";
    },
    resetPagination() {
      this.LoaderStatus = true;
      this.page = 0;
      this.allcustomerDetails = [];
      this.allVendorDetails = [];
      this.showLoader = false;
      if (this.tabName == "customer") {
        this.getCustomers();
      } else {
        this.getVendors();
      }
    },
    onScroll(e) {
      const { target } = e;
      if (
        Math.ceil(target.scrollTop) >=
        target.scrollHeight - target.offsetHeight
      ) {
        if (this.checkbetween(this.pageEnd, 0, this.total)) {
          this.page++;
          if (this.tabName == "customer") {
            this.getCustomers();
          } else {
            this.getVendors();
          }
        }
      }
    },
    checkbetween(x, min, max) {
      return x > min && x < max;
    },
    async getCustomers() {
      try {
        let payload = {
          searchQuery: this.searchQuery,
          sortColumn: this.sortColumn,
          sortOrder: this.sortOrder,
          type: this.typeSelected,
          page: this.page,
          count: this.count,
          customerType: this.custSelected,
          manage: true,
        };
        const res = await getCustomer(payload);
        if (res.status == 200) {
          if (this.page == 0) {
            this.allcustomerDetails = res.data.data.data;
          } else {
            this.allcustomerDetails = [
              ...this.allcustomerDetails,
              ...res.data.data.data,
            ];
          }
          this.total = res.data.data.total;
          this.pageEnd = res.data.data.pageEnd;
          if (res.data.data.total == res.data.data.pageEnd) {
            this.showLoader = false;
          } else {
            this.showLoader = true;
          }
          this.LoaderStatus = false;
        }
      } catch (error) {
        console.error(error);
      }
    },
    async getVendors() {
      try {
        let payload = {
          searchQuery: this.searchQuery,
          sortColumn: this.sortColumn,
          sortOrder: this.sortOrder,
          type: this.typeSelected,
          page: this.page,
          count: this.count,
        };
        const res = await getVendor(payload);
        if (res.status == 200) {
          if (this.page == 0) {
            this.allVendorDetails = res.data.data.data;
          } else {
            this.allVendorDetails = [
              ...this.allVendorDetails,
              ...res.data.data.data,
            ];
          }
          this.total = res.data.data.total;
          this.pageEnd = res.data.data.pageEnd;
          if (res.data.data.total == res.data.data.pageEnd) {
            this.showLoader = false;
          } else {
            this.showLoader = true;
          }
          this.LoaderStatus = false;
        }
      } catch (error) {
        console.error(error);
      }
    },
    particularCandidatedetail(scustomer) {
      this.singleCustomer = scustomer;
      if (!this.singleCustomer.customFields)
        this.singleCustomer.customFields = {};
      if (this.singleCustomer.customerType === "1") {
        this.customFields = this.internalDepartment;
      } else {
        this.customFields = this.clientHiring;
      }
      this.preview = scustomer.customerID;
      this.showdetails = true;
      this.singleCustomer.createdAt = this.singleCustomer.createdAt.substring(
        0,
        10
      );
    },
    particularVendordetail(svendor) {
      this.singleVendor = svendor;
      if (!this.singleVendor.customFields) this.singleVendor.customFields = {};
      this.customFields = this.vendorFields;
      this.vendorpreview = svendor.vendorID;
      this.vendshowdetails = true;
      this.singleVendor.createdAt = this.singleVendor.createdAt.substring(
        0,
        10
      );
    },
    goToAddCustomer() {
      this.$router.push({
        name: "AddCustomer",
        query: {
          status: this.$route.query.status,
          type: this.typeSelected,
          sort: this.$route.query.sort,
          customerType: this.custSelected,
        },
      });
    },
    goToAddVendor() {
      this.$router.push({
        name: "AddVendor",
        query: {
          status: this.$route.query.status,
          type: this.typeSelected,
          sort: this.$route.query.sort,
        },
      });
    },
    editCustModal(cust) {
      let type;
      if (cust.active) {
        type = 1;
      } else {
        type = 0;
      }
      this.$router.push({
        path: `editcustomer/${cust.customerID}/${type}`,
        query: {
          status: this.$route.query.status,
          type: this.typeSelected,
          sort: this.$route.query.sort,
          customerType: this.custSelected,
        },
      });
    },
    activateCustModal(cust) {
      let type;
      if (cust.active) {
        type = 1;
      } else {
        type = 0;
      }
      this.$router.push({
        path: `activatecustomer/${cust.customerID}/${type}`,
        query: {
          status: this.$route.query.status,
          type: this.typeSelected,
          sort: this.$route.query.sort,
          customerType: this.custSelected,
        },
      });
    },
    editVendModal(vend) {
      let type;
      if (vend.active) {
        type = 1;
      } else {
        type = 0;
      }
      this.$router.push({
        path: `editvendor/${vend.vendorID}/${type}`,
        query: {
          status: this.$route.query.status,
          type: this.typeSelected,
          sort: this.$route.query.sort,
        },
      });
    },
    activateVendModal(vend) {
      let type;
      if (vend.active) {
        type = 1;
      } else {
        type = 0;
      }
      this.$router.push({
        path: `activatevendor/${vend.vendorID}/${type}`,
        query: {
          status: this.$route.query.status,
          type: this.typeSelected,
          sort: this.$route.query.sort,
        },
      });
    },
    deleteCustModal(cust) {
      this.delCustomer = cust;
    },
    deleteVendor(vend) {
      this.delVendor = vend;
    },
    // delete Customer
    async deleteCustomer(cust) {
      try {
        const res = await deleteCustomer(cust);
        if (res.status == 200) {
          this.successModal("Customer has been deleted.");
          this.resetFilter();
          this.resetPagination();
          this.showdetails = false;
          this.tabName = "customer";
          this.preview = "";
        } else if (res.status == 409) {
          this.warning = true;
        } else {
          this.errorModal("Something went wrong!");
        }
      } catch (err) {
        this.errorModal("Something went wrong!");
        throw err;
      }
      this.$bvModal.hide("deleteCustModal");
    },
    // delete Vendor
    async deleteVen(vend) {
      try {
        const res = await deleteVendor(vend);
        if (res.status == 200) {
          this.successModal("Vendor has been deleted.");
          this.resetFilter();
          this.resetPagination();
          this.vendshowdetails = false;
          this.tabName = "manage";
          this.vendorpreview = "";
        } else {
          this.errorModal("Something went wrong!");
        }
      } catch (err) {
        this.errorModal("Something went wrong!");
        throw err;
      }
      this.$bvModal.hide("deleteVendModal");
    },
  },
};
</script>
